import DeleteSpecDetailContainer from "./DeleteSpecDetailContainer";
export default DeleteSpecDetailContainer;
